// Shoppable image (content-sections.md §2.8): clicking a hotspot or its bottom-bar thumbnail makes both active;
// clicking elsewhere clears the active state. Hover and focus are handled in CSS.
(function () {
  if (window.shoppableImage) return;
  const clear = (scope) => {
    scope.querySelectorAll('.is-active').forEach((el) => el.classList.remove('is-active'));
    scope.querySelectorAll('.has-active-state').forEach((el) => el.classList.remove('has-active-state'));
    scope.querySelectorAll('.has-active-thumbnail').forEach((el) => el.classList.remove('has-active-thumbnail'));
  };
  const activate = (block, id) => {
    clear(block);
    block.querySelector(`.hotspot__identifier[data-hotspot-id="${id}"]`)?.classList.add('is-active');
    block.querySelector(`.hotspot__identifier[data-hotspot-id="${id}"] .hotspot__wrapper`)?.classList.add('has-active-state');
    const thumb = block.querySelector(`[data-bottom-bar-thumbnail][data-hotspot-id="${id}"]`);
    if (thumb) { thumb.classList.add('is-active'); thumb.parentElement.classList.add('has-active-thumbnail'); }
  };
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-hotspot], [data-bottom-bar-thumbnail]');
    document.querySelectorAll('[data-shoppable-image-block]').forEach((block) => {
      if (!trigger || !block.contains(trigger)) clear(block);
    });
    if (!trigger) return;
    const block = trigger.closest('[data-shoppable-image-block]');
    const id = trigger.closest('[data-hotspot-id]').dataset.hotspotId;
    activate(block, id);
  });
  window.shoppableImage = { activate, clear };
})();
